import { BaseTag }   from "./base_mixin";
import watch from "redux-watch";
import isEqual from 'is-equal';
import serialize        from 'utilities/serialize';
import { deepmerge }    from 'utilities/merge';
import visit            from 'utilities/visit';
import { parse, stringify } from "query-string";
// import SirTrevor from 'sir-trevor';
import {
  BEFORE_VALIDATION,
  AFTER_VALIDATION,
  BEFORE_SUBMIT,
  AFTER_SUBMIT
} from 'apps/events';

class Form extends BaseTag {
  submitFunction: Function;
  protected formElement(){
    return this.rootElement().querySelector('form')
  }
}

export class BaseForm extends Form {
  /**
   * status
   * [undefined,    //初期値  ユーザーからの操作を待機中
   *  'validating', //バリデーションを実行中
   *  'connecting'  //データのレスポンスを待機中
   * ]のいずれか
   */
  scene: any; // バリデーションを状況によって分けたい時に利用。payloadにこの値が入るのでvalidator側で分岐に利用する。
  validFunction:  Function;
  isJustValidation: boolean;
  init(){
    super.init();
    this.watch();
    this.setValidations();
  }

  protected setValidations(){}
  protected submit(){}

  protected watchAbout(inputTag: string, callback: (newVal: any, oldVal: any, objectPath: string) => void = null){
    if(!callback) {
      let funcName = 'onChange_' + inputTag.replace(/\./g, '_');
      this[funcName] = (newVal: any, oldVal: any, objectPath: string) => {
        this.dispatchValidation(newVal, inputTag);
      };
      callback = this[funcName];
    }
    let scope = 'data.' + this.tagScope + '.inputs.' + inputTag + '.value';
    let w = watch(App.store.getState, scope, isEqual);
    let func = (newVal, oldVal, objectPath) => { callback(newVal, oldVal, objectPath); }
    let unsubscribe = App.store.subscribe(w( func ));
    this.on('unmount', () => { unsubscribe(); })
  }
  protected dispatchValidation(newVal, target, scope = this.tagScope){
    if(newVal == undefined) return;
    App.store.dispatch(this.validFunction({target: target,baseScope: this.tagScope}));
  }
  protected status(){
    return this.data().status;
  }

  public onSubmit(e){
    e.preventDefault();
    if(this.validFunction){
      this.valid();
    } else {
      this.onValid();
    }
    return false;
  }
  protected valid(){
    this.formElement().dispatchEvent(new CustomEvent(BEFORE_VALIDATION));
    let callback = (validator) => { this.onValid(validator); }
    let payload = { target: 'all', callback: callback, baseScope: this.tagScope };
    if(this.scene){
      payload['scene'] = this.scene;
    }
    App.store.dispatch(this.validFunction(payload));
  }

  public onValid(validator = null){
    this.formElement().dispatchEvent(new CustomEvent(AFTER_VALIDATION));
    let error = validator == undefined ? false : validator.newVal.error
    if(this.isJustValidation){
      this.isJustValidation = false;
    } else if(!error){
      this.formElement().dispatchEvent(new CustomEvent(BEFORE_SUBMIT));
      this.submit();
      this.formElement().dispatchEvent(new CustomEvent(AFTER_SUBMIT));
    }
  }

  public disableAll(){
    let newVal = { inputs: {} };
    for(let key in this.opts.inputs){
      newVal.inputs[key] = { disable: true };
    }
    this.dispatch(newVal);
  }
  public enableAll(){
    let newVal = { inputs: {} };
    for(let key in this.opts.inputs){
      newVal.inputs[key] = { disable: false };
    }
    this.dispatch(newVal);
  }
  protected getNewURI(query){
    if(query == '') return location.pathname;
    let current = location.pathname + '?' + location.search.replace('?', '');
    let next    = location.pathname + '?' + query;
    if(current == next) return null;
    return next;
  }
}

export class DestroyForm extends Form {
  public onSubmit(e){
    e.preventDefault();
    this.submit();
    return false;
  }
  protected submit(){}
}

export class SearchFormBase extends BaseForm {
  protected submit(){ //normal access (not ajax)
    let form   = this.getParamsByData();
    let search = this.getParamsBySearch();
    let queryObj = deepmerge(search, form);
    let query = serialize(queryObj);
    let uri = this.getNewURI(query);
    if(uri != null){
      visit(uri);
    }
    return false;
  }
  protected validKey(key){
    return false; //override on subclass
  }
  protected getParamsBySearch(){
    let params = parse(window.location.search);
    let newParams = {};
    for(let key in params){
      if(this.validKey(key)) continue;
      // if(/^[k|s|t|c|u|p|h|r|m|b]$/.test(key)) continue;
      // if(/^page$/.test(key)) continue;
      newParams[key] = params[key];
    }
    return newParams;
  }
  public onSubmit(e){
    e.preventDefault();
    this.submit();
    return false;
  }
  protected setParamsByKey(inputs, key, params){
    // ex.
    //   let name = inputs[key].name
    //   params[name] = inputs[key].value
  }
  protected getParamsByData(){
    let params = {}
    let inputs = this.opts.inputs
    for(let key in inputs){
      this.setParamsByKey(inputs, key, params)
    }
    return params
  }
}
